import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"

export const getUserProjects = api(async function getUserProjects({ searchTerm, phase, archived, orderStmt } = {}) {
    return query(
        gql`
            query GetUserProjects($searchTerm: String, $phase: ProjectPhase, $archived: Boolean, $orderStmt: [String]) {
                getUserProjects(searchTerm: $searchTerm, phase: $phase, archived: $archived, orderStmt: $orderStmt) {
                    projects {
                        id
                        _id
                        _modified
                        _created
                        name
                        internalDescription
                        phase
                        archived
                        archivedAt
                        scheduleIds
                        scopedScheduleIds
                        groups {
                            id
                            name
                        }
                    }
                    total
                }
            }
        `,
        { searchTerm, phase, archived, orderStmt },
        { returns: "getUserProjects" }
    )
})
